<template>
  <div class="candidatereg-main-caontainer">
    <div class="work-container relativeclass farewell-top-container">
      <img src="../../assets/img/h3xlogo.svg" class="mb-5" alt="" />
      <div class="farewell-first-div">Thanks for Submitting!</div>
      <br />
      <div class="farewell-second-div">
        The registration process has been completed successfully. You will hear
        back from us soon.
      </div>
      <br />
      <b-button class="addbtn" @click="navigateWebSite">
        Go to Hire3x
      </b-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "FareWellPage",
  methods: {
    navigateWebSite() {
      location.replace("https://hire3x.com/");
    },
  },
};
</script>
